export default __webpack_public_path__ + "static/media/book_room.d9dbcc23.png";